const EOS = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill="white" />
    <path
      d="M10.2526 1.06418L6.12052 6.69983L4.37604 15.0433L10.2526 18.5721L16.1291 15.0433L14.3847 6.69983L10.2526 1.06418ZM7.27171 6.84646L10.2526 2.85166L13.2248 6.84646L10.2526 15.9081L7.27171 6.84646ZM13.7533 8.52497L14.9501 14.4936L11.0487 16.8096L13.7533 8.52497ZM5.56194 14.4936L6.69661 8.40063L9.4944 16.8096L5.56194 14.4936Z"
      fill="#35354C"
    />
  </svg>
);
export default EOS;
